module.exports = __webpack_public_path__ + "assets/img/26_873_big.9f69163b.jpg";